"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const auth0_react_1 = require("@auth0/auth0-react");
const react_1 = require("react");
const react_retool_1 = __importDefault(require("react-retool"));
const components_1 = require("components");
const config_1 = require("config");
function AdminPortal() {
    const { logout, getAccessTokenSilently } = (0, auth0_react_1.useAuth0)();
    const [loaded, setLoaded] = (0, react_1.useState)(false);
    const [token, setToken] = (0, react_1.useState)({ token: '' });
    // Fetch token and make available to Retool
    (0, react_1.useEffect)(() => {
        getAccessTokenSilently().then((result) => {
            setToken({ token: result });
        });
    }, []);
    // Do not allow render until token is available
    (0, react_1.useEffect)(() => {
        setLoaded(!!token['token']);
    }, [token]);
    if (loaded) {
        return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.LinkButton, { className: "button-warn-outline link-button-internal-logout", onClick: () => logout({ returnTo: (0, config_1.makeApplicationURL)(config_1.PATH.ADMIN) }), children: "Sign Out" }), (0, jsx_runtime_1.jsx)(react_retool_1.default, { url: config_1.REACT_APP_ALPHAEON_RETOOL_EMBED_URL, data: token })] }));
    }
    else {
        return (0, jsx_runtime_1.jsx)("div", { children: "Loading..." });
    }
}
exports.default = AdminPortal;
